// extracted by mini-css-extract-plugin
export default {"wrapper":"tG","subscription":"uG","select_item":"vG","is_selected":"wG","otb":"xG","radio":"yG","first_row":"zG","prices":"AG","italic":"BG","info_wrapper":"CG","first_month":"EG","separator":"FG","checkmark":"GG","bullets":"HG","bullet":"IG","checkmarkText":"JG","button":"KG","discountBadge":"LG"};
    if(module.hot) {
      // 1738836196945
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  